import axios from "axios";
import { generateHmacHeaders } from './hmacUtils';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

let isLoggingOutFront = false;

export const handleUnauthorizedFront = () => {
  if (isLoggingOutFront) return;

  const currentPath = window.location.pathname;
  if (currentPath.startsWith("/login")) {
    return;
  }

  isLoggingOutFront = true;

  try {
    localStorage.removeItem("token");
    localStorage.removeItem("udata");
    localStorage.removeItem("userId");
    localStorage.removeItem("phone");
  } catch (err) {
    console.error("Error clearing user session:", err);
  }

  // Redirect to login page
  window.location.href = "/login";
};

const isLoginRequest = (url = "") => {
  if (!url) return false;
  const str = String(url).toLowerCase();
  return (
    str.includes("login/finish") ||
    str.includes("/login") ||
    str.endsWith("login") ||
    str === "login"
  );
};

// Global Axios response interceptor for 401 Unauthorized
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error?.response?.status === 401) {
      const requestUrl = error?.config?.url || "";
      if (!isLoginRequest(requestUrl)) {
        handleUnauthorizedFront();
      }
    }
    return Promise.reject(error);
  }
);

export const apiRequest = async (endpoint, method = "GET", data = null, headers = {}) => {
  const url = `${API_BASE_URL}/${endpoint}`;
  const currentTime = new Date().toISOString();

  // Safeguard: If data only contains Authorization header and headers is empty, caller passed headers as 3rd arg
  if (
    data &&
    typeof data === "object" &&
    !(data instanceof FormData) &&
    data.Authorization &&
    Object.keys(data).length === 1 &&
    Object.keys(headers).length === 0
  ) {
    headers = data;
    data = null;
  }

  // Generate HMAC security headers
  const hmacHeaders = generateHmacHeaders({
    method,
    endpoint,
    data,
  });

  const options = {
    method: method,
    headers: {
      ...(data instanceof FormData ? {} : { "Content-Type": "application/json" }),
      ...headers,
      ...hmacHeaders,
      'X-Current-Time': currentTime,
    },
  };

  if (data !== null && data !== undefined) {
    options.data = data;
  }

  try {
    const response = await axios(url, options);

    if (!response) {
      throw new Error(`Error: ${response.status}`);
    }

    return response;
  } catch (error) {
    if (error?.response?.status === 401) {
      if (!isLoginRequest(endpoint) && !isLoginRequest(url)) {
        handleUnauthorizedFront();
      }
    }
    console.error("API request failed:", error);
    throw error;
  }
};
